












































import { Component, Ref, Vue, Watch } from 'vue-property-decorator';
import { refsService } from '@/app/shared/refs.service';
import { InteractionModel, VForm } from '@/app/shared/models';
@Component
export default class DialogEndServiceComponent extends Vue {
  @Ref() private form!: VForm;

  private dialog = false;
  private reason = '';
  private valueTab = '';

  private get refs() {
    return refsService;
  }
  private get rules() {
    return this.refs.static.rules;
  }
  private async completeTicket() {
    if (this.form && this.form.validate()) {
      await this.refs.modules.ticket
        .createInteraction(
          new InteractionModel(this.$t('action_code.ac10'), this.valueTab)
        )
        .then(() => {
          localStorage.removeItem('tabulacao');
          this.$bus.$emit('cleanValueTab');
        });

      this.refs.modules.ticket
        .closeTicket(this.refs.modules.ticket.ticket.Id)
        .then(() => {
          this.$toast(this.$t('toasts.ending_service_successfully'));
          this.$router.push({ name: 'contracts' });
          this.dialog = false;
        })
        .catch((err) => {
          this.$toast.error('ERROR ? ', err);
          this.$toast.error(this.$t('toasts.ending_service_error'));
        });
    }
  }

  @Watch('dialog')
  private onChangeDialog(value: boolean): void {
    this.valueTab = localStorage.getItem('tabulacao') ?? '';
    if (value && this.form) this.form.resetValidation();
  }
}
